import VueExcelXlsx from "./VueExcelXlsx.vue";

export default {
    install(Vue, options) {
        Vue.component("vue-excel-xlsx", VueExcelXlsx);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-excel-xlsx/index.js
// module id = p39F
// module chunks = 0